import parse from 'html-react-parser'
import { ReactNode } from 'react'

import { PaymentCardLabels } from '@enums'

const URL_REGEX = /((?:(?:https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|$!:,.;]+[A-Z0-9+&@#/%=~_|$]))(?![^<]*<\/a>)/gim

const format = (text: string): ReactNode => {
  const createLink = (link: string): string => `<a rel='noreferrer' target='_blank' href=${link}>${link}</a>`

  return parse(text.replace(URL_REGEX, createLink))
}

const isExplicitlyEmpty = (text: string): boolean => {
  return text?.trim() === ''
}

export const getPaymentMethodLabelAlt = (t: Function, type: string): string => {
  if (type in PaymentCardLabels) {
    return PaymentCardLabels[type as keyof typeof PaymentCardLabels]
  } else {
    return t(`checkout.paymentMethods.${type}`)
  }
}

export default {
  format,
  isExplicitlyEmpty,
}
